// 某天时间 传入Date
const getDateFun = function(date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();
    let obj = {
        year: formatNumber(year),
        month: formatNumber(month),
        day: formatNumber(day),
        date: `${[year, month, day].map(formatNumber).join("-")}`,
        daytime: `${[year, month, day].map(formatNumber).join("-")} ${[
            hour,
            minute,
            second,
        ]
            .map(formatNumber)
            .join(":")}`,
    };
    // 返回年月日
    return obj;
};
const formatNumber = (n) => {
    n = n.toString();
    return n[1] ? n : `0${n}`;
};
const getUrlParams = function(url){
	let theRequest = new Object();
	if(url.indexOf('?') != -1){
		let index = url.indexOf('?');
		let params = url.slice(index+1,url.length);
		let paramsArr = params.split('&');
		for (let i = 0; i < paramsArr.length; i++) {
			theRequest[paramsArr[i].split("=")[0]] = paramsArr[i].split("=")[1];
		}
	};
	return theRequest;
}
export default {
	getDateFun,
	getUrlParams
}